module.exports = __webpack_public_path__ + "31ca70bf5b8731872fc6575818ab44a4.png";